import ElementUI from 'element-ui';
import ViewUI from 'view-design';
// 全局样式
import './index.less';
// 动态切换主题方法
function changeTheme() {
  const currentTheme = localStorage.getItem('theme');
  console.log('changeTheme', currentTheme);
  if (currentTheme === 'red' || currentTheme === null) {
    import('./red.less');
  } else if (currentTheme === 'black') {
    import('./black.less');
  } else if (currentTheme === 'blue') {
    import('./blue.less');
  }
}

// 全局挂载到 Vue 原型，方便在组件中调用
Vue.prototype.$changeTheme = changeTheme;
changeTheme();
// import 'view-design/dist/styles/iview.css'; // 默认主题
import 'element-ui/lib/theme-chalk/index.css';

// 全局指令
import importDirective from '@/directive';
// 全局字体
import '@/assets/icons/iconfont.css';
// 全局字体
import '@/assets/icons/icon.css';
// 引入权限
import './router/permission';
// 按需引入组件库
import './libs/install.js';
//引入字体
import '@/assets/css/fonts.css';
// 自定义弹窗
import customDialog from './components/custom-dialog/main';
// 文件预览
import lookOverFile from './components/look-over-file/index';
// 用户手册
import procedures from './components/procedures/index';
// AI mini聊天室
import miniChat from './components/mini-chat/index';

import * as echarts from 'echarts';
import _ from 'lodash'; // 导入lodash

//富文本编辑器
import iEditor from 'iview-editor';
//样式
import 'iview-editor/dist/iview-editor.css';
import './assets/styles/message.css'; // 引入自定义样式
import forward from '_c/forward/index.vue';
import selectGrop from '_c/selectGrop/index.vue';
import selectGropFile from '_c/selectGropFile/index.vue';
import richTextEditor from '_c/richTextEditor/index.vue';
import fileUpload from '_c/fileUpload/index.vue'; // 引入文件上传组件
import fileUploadT from '_c/fileUploadT/index.vue'; // 引入文件上传组件
import fileUploadEditor from '_c/fileUploadEditor/index.vue';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import VuePrintNb from 'vue-print-nb';
import Vue from 'vue';
import App from './App';
import store from './store';
import config from '@/config';
import router from './router';

import tinymce from 'tinymce';
import VueTinymce from '@packy-tang/vue-tinymce';

Vue.prototype.$tinymce = tinymce; // 将全局tinymce对象指向给Vue作用域下

Vue.use(VueTinymce);
Vue.use(ViewUI);
Vue.use(iEditor);
Vue.use(ElementUI);
Vue.use(VuePrintNb);
Vue.prototype.$echarts = echarts;
Vue.prototype.$iEditor = iEditor;
Vue.prototype.$JSZip = JSZip;
Vue.prototype.$saveAs = saveAs;
Vue.prototype.$_ = _; // 将lodash挂载到Vue实例的原型上
// 定义全局编码表情包
Vue.prototype.$encodeEmoji = function (text) {
  return text.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, function (match) {
    return '&#' + match.codePointAt(0) + ';';
  });
};
// 定义全局解码表情包
Vue.prototype.$decodeEmoji = function (text) {
  return text.replace(/&#(\d+);/g, function (match, dec) {
    return String.fromCodePoint(dec);
  });
};
// 定义全局解码表情包并移除乱码字符（如 ?）
Vue.prototype.$revertSpecialCharacters = function (text) {
  return (
    text
      .replace(/\\u2611/g, String.fromCodePoint(0x2611)) // ☑
      .replace(/\\u2610/g, String.fromCodePoint(0x2610)) // ☐
      .replace(/\\u00A9/g, String.fromCharCode(169)) // ©
      .replace(/\\u2122/g, String.fromCharCode(8482)) // ™
      // 去掉所有问号字符（包括乱码显示为 ?）
      .replace(/\?/g, '')
  );
};
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false;

/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config;

//引入Json 2 Excel
import JsonExcel from 'vue-json-excel';

Vue.component('downloadExcel', JsonExcel);
Vue.component('customDialog', customDialog);
Vue.component('lookOverFile', lookOverFile);
Vue.component('procedures', procedures);
Vue.component('miniChat', miniChat);
Vue.component('forward', forward);
Vue.component('selectGrop', selectGrop);
Vue.component('selectGropFile', selectGropFile);
Vue.component('richTextEditor', richTextEditor);
Vue.component('fileUpload', fileUpload);
Vue.component('fileUploadT', fileUploadT);
Vue.component('fileUploadEditor', fileUploadEditor);
/**
 * 注册指令
 */
importDirective(Vue);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

/**
 * @description
 * @author (Set the text for this tag by adding docthis.authorName to your settings file.)
 * @date 2019-05-29
 * @param { number } type 1 localStorage 2 sessionStorage
 * @param { string } key 键
 * @param { string } data 要存储的数据
 * @returns
 */

Vue.prototype.$addStorageEvent = function (type, key, data) {
  if (type === 1) {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          'setItem',
          false,
          false,
          k,
          null,
          val,
          null,
          null,
        );
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      },
    };
    return storage.setItem(key, data);
  } else {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          'setItem',
          false,
          false,
          k,
          null,
          val,
          null,
          null,
        );
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      },
    };
    return storage.setItem(key, data);
  }
};
